export const career_routes = [
  {
    path: "/careers",
    component: () => import("../Main.vue"),
    name: "Licenças"
  },
  {
    path: "/premiacoes",
    component: () => import("../MainAward.vue"),
    name: "Premiações"
  },
];

export default {};
